// PropertiesDetailsArea.js
import React from "react";
import { useParams, Link } from "react-router-dom";
import { properties } from "../properties";

const PropertiesDetailsArea = () => {
  const { id } = useParams();
  const property = properties.find((item) => item.id === parseInt(id));

  if (!property) {
    return <div className="container py-5">Property not found</div>;
  }

  return (
    <section className="vs-property-details space-top space-extra-bottom">
      <div className="container">
        {/* HEADER */}
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-9">
            <span className="sec-subtitle">Property Details</span>
            <h1 className="sec-title">{property.name}</h1>
            <p className="sec-text">{property.description}</p>
          </div>
        </div>

        {/* MAIN CONTENT */}
        <div className="row gx-40 align-items-start">
          {/* IMAGE */}
          <div className="col-lg-6 mb-4">
            <div className="property-image-box">
              <img
                src={property.imageUrl}
                alt={property.name}
                className="w-100 rounded-3 shadow"
                style={{ height: "600px" }}
              />
            </div>
          </div>

          {/* INFO */}
          <div className="col-lg-6">
            <div className="property-info-box shadow-sm rounded-3 p-3">
              <h3 className="mb-4">Property Information</h3>

              <ul className="property-info-list">
                <li>
                  <span>📍 Location : </span>
                  <strong>{property.location}</strong>
                </li>
                <li>
                  <span>🏢 Building Type : </span>
                  <strong>{property.buildingStructure || "N/A"}</strong>
                </li>
                <li>
                  <span>🛏 Room Types : </span>
                  <strong>{property.roomTypes || "N/A"}</strong>
                </li>
                <li>
                  <span>🏘 Total Units : </span>
                  <strong>{property.totalUnits || "N/A"}</strong>
                </li>
                <li>
                  <span>💰 Price : </span>
                  <strong>{property.price}</strong>
                </li>
              </ul>

              {/* ROOM BREAKDOWN */}
              <div className="row mt-5">
                <div className="col-lg-12">
                  <div className="property-room-box shadow-sm rounded-3">
                    <h3 className="mb-4 text-center">Room Breakdown</h3>

                    <div className="row text-center">
                      <div className="col-md-3 col-6 mb-3">
                        <div className="room-card">
                          <h4>{property.roomDetails?.studio || 0}</h4>
                          <p>Studios</p>
                        </div>
                      </div>
                      <div className="col-md-3 col-6 mb-3">
                        <div className="room-card">
                          <h4>{property.roomDetails?.oneBHK || 0}</h4>
                          <p>1 BHK</p>
                        </div>
                      </div>
                      <div className="col-md-3 col-6 mb-3">
                        <div className="room-card">
                          <h4>{property.roomDetails?.twoBHK || 0}</h4>
                          <p>2 BHK</p>
                        </div>
                      </div>
                      <div className="col-md-3 col-6 mb-3">
                        <div className="room-card">
                          <h4>{property.roomDetails?.threeBHK || 0}</h4>
                          <p>3 BHK</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <Link
                to="/contact"
                className="vs-btn style4 mt-4 w-100 text-center"
              >
                Contact Us About This Property
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PropertiesDetailsArea;
